<app-tab>
  <dx-tree-list
    id="cropsGridContainer"
    dataStructure="plain"
    keyExpr="id"
    parentIdExpr="parent_id"
    [libTreeListTitle]="{ text: 'Cultures' }"
    [libTreeListDefault]="{ stateStorageKey: 'app-crops-tree' }"
    [height]="height"
    (onRowInserted)="reloadDatasource($event)"
    (onRowUpdated)="reloadDatasource($event)"
    (onRowRemoved)="reloadDatasource($event)"
    [autoExpandAll]="false"
    [rowAlternationEnabled]="true"
    [showRowLines]="true"
    [dataSource]="ds"
    [rootValue]="null"
  >
    <dxi-column
      caption="Nom"
      dataField="name"
      cellTemplate="cellTemplate"
      dataType="string"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="255"
      ></dxi-validation-rule>
    </dxi-column>
    <div *dxTemplate="let cell of 'cellTemplate'">
      <div class="flex flex-row items-center">
        <span
          style="width: 18px; height: 18px"
          class="block border border-solid border-gray-300 mx-2"
          [ngStyle]="{ backgroundColor: cell.data.color || '#ffffff' }"
        ></span>
        <span class="block mr-2 px-2">{{ cell.text }} </span>
      </div>
    </div>

    <dxi-column caption="Code" dataField="code" dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Description" dataField="description" dataType="string">
      <dxi-validation-rule
        type="stringLength"
        [min]="0"
        [max]="1024"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="parent_id"
      caption="Parent"
      editCellTemplate="cropEditor"
      [showInColumnChooser]="false"
      [allowFiltering]="false"
      [allowSearch]="false"
      [visible]="false"
    >
      <div *dxTemplate="let cellInfo of 'cropEditor'">
        <app-crop-selector
          [items]="items"
          [value]="cellInfo.value"
          (valueChange)="cellInfo.setValue($event)"
        ></app-crop-selector>
      </div>
    </dxi-column>

    <dxi-column
      caption="Couleur"
      [showInColumnChooser]="false"
      [allowFiltering]="false"
      [allowSearch]="false"
      [visible]="false"
      dataField="color"
    >
      <dxo-form-item
        editorType="dxColorBox"
        [editorOptions]="{ applyValueMode: 'instantly' }"
      >
      </dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit"
    >
      <dxo-popup width="30%" height="520"></dxo-popup>

      <dxo-form colCount="1">
        <dxi-item dataField="name"></dxi-item>
        <dxi-item dataField="code"></dxi-item>
        <dxi-item dataField="parent_id"></dxi-item>
        <dxi-item dataField="color"></dxi-item>
        <dxi-item
          dataField="description"
          editorType="dxTextArea"
          [editorOptions]="{ height: 100 }"
        ></dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export
      [enabled]="true"
      fileName="liste-cutltures-"
      [allowExportSelectedData]="true"
    ></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-tree-list>
</app-tab>
